const PremiumLightValues = Object.freeze({
    base: {
        default: '#158380',
        action: '#0E5957',
        active: '#158380',
        activeAction: '#0E5957',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const PremiumDarkValues = Object.freeze({
    base: {
        default: '#158380',
        action: '#0E5957',
        active: '#158380',
        activeAction: '#0E5957',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { PremiumDarkValues, PremiumLightValues };
